'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgWrapper = require('../../../core/SvgWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MaidIcon = function MaidIcon(props) {
  return React__default["default"].createElement(SvgWrapper, _objectSpread({}, props), React__default["default"].createElement("g", {
    id: "onboarding-/-industry-/-home-cleaning",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default["default"].createElement("path", {
    d: "M27.8426479,2 L30,4.15735214 L21.3098209,12.8323386 C22.9354314,15.1720022 23.1633207,17.982637 21.7959848,19.8057515 L12.1942485,10.2040152 C14.017363,8.83667933 16.8279978,9.06456864 19.1676614,10.6901791 L27.8426479,2 L27.8426479,2 Z M7.43895822,24.5610418 C4.38524145,21.507325 2.5165491,17.861096 2,14.457949 L9.41399891,11.2826913 L20.7173087,22.5860011 L17.542051,30 C14.138904,29.4834509 10.492675,27.6147585 7.43895822,24.5610418 Z",
    id: "Shape"
  })));
};

module.exports = MaidIcon;
